import getPublicPath from 'src/webpack-get-public-path';

/* eslint-disable camelcase */
__webpack_public_path__ = getPublicPath(window.location.host);
